import { Tooltip } from '@material-ui/core';
import React from 'react';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loading from '../../../components/Loading';
import { formatDateToRender, formatDateTimeToRender } from '../../../utils/functions';
import * as S from './styles';

function ScheduledTable({ data, isLoading, clickProvider }) {
  if (isLoading) {
    return (
      <>
        <S.TableTitleHeader>
          <h3 className="operation-title">Anotações</h3>
        </S.TableTitleHeader>
        <Loading />
      </>
    );
  }

  return (
    <S.AnotationContainer>
      <S.TableTitleHeader>
        <h3 className="operation-title">Resultado da pesquisa dos agendamentos</h3>
        <div className="anotation-body-header">
          <span>Data</span>
          <span className="provider-field">Fornecedor</span>
          <span className="user-field">Usuário</span>
          <span>Agendamento</span>
        </div>
      </S.TableTitleHeader>

      <S.AnotationBody>
        {data?.map((anotation, key) => (
          <div className="anotation-body-message pointer" key={key}
            style={{
              backgroundColor: anotation.corFundo ? anotation.corFundo : 'auto',
              color: anotation.corFonte ? anotation.corFonte : 'auto'
            }}
            onClick={() => clickProvider(anotation)}
          >
            <div className="anotation-message-header">
              <span className="text-center">{formatDateTimeToRender(anotation?.dataRegistro)}</span>
              <Tooltip placement="top" title={anotation?.fornecedor}>
                <span className="provider-field pointer">
                  {anotation?.fornecedor?.length >= 31
                    ? anotation?.fornecedor?.slice(0, 31) + '...'
                    : anotation?.fornecedor}
                </span>
              </Tooltip>
              <Tooltip placement="top" title={anotation?.operador}>
                <span className="user-field text-left">
                  {anotation?.operador?.length >= 28
                    ? anotation?.operador?.slice(0, 28) + '...'
                    : anotation?.operador}
                </span>
              </Tooltip>
              <span className="text-center">{formatDateTimeToRender(anotation?.dataAgendamento)}</span>
            </div>
            <p>{anotation?.ocorrencia}</p>
          </div>
        ))}
      </S.AnotationBody>
    </S.AnotationContainer>
  );
}

export default ScheduledTable;
